export enum TagType {
	light = 'light',
	yellow = 'yellow',
	blue = 'blue',
	gray = 'gray'
}
